// extracted by mini-css-extract-plugin
module.exports = {"container":"e_jA","title":"e_kA","label":"e_lA"};